module.exports = __webpack_public_path__ + "img/finance-chart.7523d8ae.png";